import { Badge } from './Badge.jsx';

/**
 * Renders inside a check's expanded panel when there are no findings and
 * no activity table applies — e.g. Check #17 or any check whose threshold
 * was met. Matches the PDF "NO ISSUES FOUND" cover copy.
 */
export function EmptyStatePass({ message }) {
  const copy = message
    || 'No activities exceed the threshold for this check.';
  return (
    <div className="empty-pass" role="status">
      <Badge variant="OK">NO ISSUES FOUND</Badge>
      <p className="empty-pass-copy">{copy}</p>
    </div>
  );
}
